module.exports = __webpack_public_path__ + "img/515341_9A9C86_16180D_838474-256px.321a3e0b.png";